import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { create } from "zustand";

type LightGatingStore = {
  isDrawerVisible: boolean;
  isDrawerMinimized: boolean;
  setIsDrawerVisible: (isOpen: boolean) => void;
  setIsDrawerMinimized: (isMinimized: boolean) => void;
  image?: IImage;
  setImage: (image: IImage) => void;
  onDrawerMinimized: () => void;
};

export const useLightGatingStore = create<LightGatingStore>((set) => ({
  isDrawerVisible: false,
  isDrawerMinimized: false,
  setIsDrawerVisible: (isOpen: boolean) => set({ isDrawerVisible: isOpen }),
  setIsDrawerMinimized: (isMinimized: boolean) =>
    set({ isDrawerMinimized: isMinimized }),
  image: undefined,
  setImage: (image: IImage) => set({ image }),
  onDrawerMinimized: () =>
    set({
      isDrawerVisible: true,
      isDrawerMinimized: true,
      image: undefined,
    }),
}));
